export default {
  formatDate(date, includeTime = false) {
    const i18n = window.VUE_CLI_EXPORTS.plugins.i18n
    return i18n.d(new Date(date), includeTime ? 'long' : 'short')
  },
}
